import { Component, OnInit, ViewChild } from '@angular/core';
import { ProductionHistoryService } from '../../../services-http/production-history/production-history.service'
import { FormBuilder,Validators,FormControl,FormGroup } from '@angular/forms';
import Swal from 'sweetalert2'
import { ModalDirective } from 'ng-uikit-pro-standard';
import { NgxSpinnerService } from 'ngx-spinner';
import { environment } from 'src/environments/environment.prod';
import { NotificationService } from '../../../services-http/notification/notification.service';
import { BillingService } from '../../../services-http/billing/billing.service';
import { debounceTime, distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';


@Component({
  selector: 'app-endorsement',
  templateUrl: './endorsement.component.html',
  styleUrls: ['./endorsement.component.scss']
})
export class EndorsementComponent implements OnInit {
  @ViewChild('basicModal') basicModal: ModalDirective;
  @ViewChild('basicModal4') basicModal4: ModalDirective;
  @ViewChild('updateEndorsement') updateEndorsement: ModalDirective;
  

  constructor(
    private product: ProductionHistoryService,
    private fb: FormBuilder,
    private spinner: NgxSpinnerService,
    private notification: NotificationService,
    private bill:BillingService
  ) { }

  endorsementForm = this.fb.group({
    policyNo: ['',Validators.required],
    remarks: ['',Validators.required],
    memo: ['',Validators.required],
    endorsement_no: [{value:'', disabled: true},Validators.required],
    w_benefit:0,
    request_endorsement_id:0
  });

  

  activeTab='request'
  endorsemet_request: any = {
    data:[]
  };

  other_fees = new FormGroup({
    total_prem: new FormControl(0.00, [Validators.required, Validators.pattern(/^[-\d]+(\.\d+)?$/)]),
    doc_stamp: new FormControl(0.00, [Validators.required, Validators.pattern(/^[-\d]+(\.\d+)?$/)]),
    misc_fee: new FormControl(0.00, [Validators.required, Validators.pattern(/^[-\d]+(\.\d+)?$/)]),
    vat: new FormControl(0.00, [Validators.required, Validators.pattern(/^[-\d]+(\.\d+)?$/)]),
    lgt: new FormControl(0.00, [Validators.required, Validators.pattern(/^[-\d]+(\.\d+)?$/)]),
    d_tech: new FormControl(0.00, [Validators.required, Validators.pattern(/^[-\d]+(\.\d+)?$/)]),
    comp_fee: new FormControl(0.00, [Validators.required, Validators.pattern(/^[-\d]+(\.\d+)?$/)]),
    amnt_due: new FormControl(0.00, [Validators.required, Validators.pattern(/^[-\d]+(\.\d+)?$/)]),
    fst: new FormControl(0.00, [Validators.required, Validators.pattern(/^[-\d]+(\.\d+)?$/)]),
    cov: new FormControl(0.00, [Validators.required, Validators.pattern(/^[-\d]+(\.\d+)?$/)])
  });


  resetForm() {
    this.endorsementForm.reset();
    this.other_fees.patchValue({
      total_prem: 0.00,
      doc_stamp: 0.00,
      misc_fee: 0.00,
      vat: 0.00,
      lgt: 0.00,
      d_tech: 0.00,
      comp_fee: 0.00,
      amnt_due: 0.00,
      fst: 0.00,
      cov: 0.00
    });
  }


  cancellationForm = new FormGroup({
    reason: new FormControl('', [Validators.required]),
    remarks: new FormControl('', [Validators.required]),
    policyno: new FormControl('', [Validators.required]),
    assured_name: new FormControl(''),
    date: new FormControl('')
  });


  get total_prem() { return this.other_fees.get('total_prem'); }
  get doc_stamp() { return this.other_fees.get('doc_stamp'); }
  get misc_fee() { return this.other_fees.get('misc_fee'); }
  get vat() { return this.other_fees.get('vat'); }
  get lgt() { return this.other_fees.get('lgt'); }
  get d_tech() { return this.other_fees.get('d_tech'); }
  get comp_fee() { return this.other_fees.get('comp_fee'); }
  get amnt_due() { return this.other_fees.get('amnt_due'); }
  get fst() { return this.other_fees.get('fst'); }
  get cov() { return this.other_fees.get('cov'); }
  

  date = new Date();
  headElements:any = ['Endorsement No','Remarks' ,'Coop Name','Memo','Premium','Endorsed By','Date', 'Action']
  endorsements:any = [];
  url=environment.url;
  search_result:any = [];
  searchText:any='';
  edits:any=false;
  edit_data:any;
  user = JSON.parse(localStorage.getItem("currentUser"));
  email:any='';
  endorse_id:any='';
  quoteDetail:any=[];
  loadingEndorsementNo =false;
  area:any='';
  l = new Date();
  dateto = this.l.toISOString().substring(0,10);
  f = new Date("2019-01-01");
  datefrom = this.f.toISOString().substring(0,10);
    private searchSubject = new Subject<string>();
  private destroy$ = new Subject<void>();


  ngOnInit() {


    this.area = this.user.location

    this.get_request_endorsement(1,false);

    this.endorsementForm.get('policyNo').valueChanges.pipe(debounceTime(2000)).subscribe(value => {
      if(value && this.edits==false){
        this.searchPolicy();
      }
    },error=>{
      this.spinner.hide();
      
      Swal.fire(
        'Error',
        'Something went wrong!',
        'error'
      );
    });


    this.searchSubject
      .pipe(
        debounceTime(2000),          
        distinctUntilChanged(),
        takeUntil(this.destroy$)
      )
      .subscribe(value => {
        this.get_request_endorsement(1,false);
      });


  }


  onSearchChange(value: string) {
    this.searchSubject.next(value);
  }



  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }



  searchPolicy(){
    this.loadingEndorsementNo=true
    // this.spinner.show()
    this.search_result = '';
    this.product.searchPolicy({policyno:this.endorsementForm.value.policyNo})
      .subscribe( (res:any)=>{
        // this.spinner.hide();
        this.loadingEndorsementNo=false
        this.search_result = res;

       
        this.search_result.benefits.forEach(row => {
          row.coverage=0.00;
          row.premium=0.00;
        });

        this.endorsementForm.patchValue({
          endorsement_no: res['policyno'] + "-" + (+res['endorsement_count'] + 1)  
        });

    },error=>{
      // this.spinner.hide()
      this.loadingEndorsementNo=false
      this.endorsementForm.reset();
      let err=error.status == 0?{msg: 'Something went wrong.'}: error.error;
      let msg='';
      
      Object.keys(err).forEach(function(key){
        msg+=err[key]+'<br/>';
      });
      
      Swal.fire(
        'Ooppss',
        msg,
        'warning'
      );
    });
  }




  save(){
    this.spinner.show()
    let endorsement = {
      endorsement_no: this.endorsementForm.getRawValue().endorsement_no,
      memo: this.endorsementForm.getRawValue().memo,
      policyNo: this.endorsementForm.getRawValue().policyNo,
      remarks: this.endorsementForm.getRawValue().remarks,
      w_benefit: this.endorsementForm.value.w_benefit==true? 1:0,
      amnt_due: this.other_fees.value.amnt_due,
      comp_fee: this.other_fees.value.comp_fee,
      d_tech: this.other_fees.value.d_tech,
      doc_stamp: this.other_fees.value.doc_stamp,
      lgt: this.other_fees.value.lgt,
      misc_fee: this.other_fees.value.misc_fee,
      total_prem: this.other_fees.value.total_prem,
      vat: this.other_fees.value.vat,
      login_id: this.search_result.agentNo,
      endorseBy: this.user.iloginId,
      fst: this.other_fees.value.fst,
      cov: this.other_fees.value.cov

    }

    let data = {
      request_endorsement_id: this.endorsementForm.getRawValue().request_endorsement_id,
      endorsement:endorsement,
      benefit:this.search_result.benefits
    }

    this.product.save( data ).subscribe(res=>{
    
      this.basicModal.hide();
      this.get_request_endorsement(1,false)
      this.endorsementForm.reset()
      this.search_result = ''
      this.other_fees.reset()
      this.spinner.hide()
      Swal.fire(
        'Success',
        res['msg'],
        'success'
      );

      this.notification.notify(res['notification']);

    },error=>{
      this.spinner.hide()

      Swal.fire(
        'Opppss',
        'Something went wrong, try again later!',
        'error'
      );
    });

  }



  edit(data){

    this.search_result =[];
    this.edit_data = data;
    this.endorsementForm.patchValue(data);
    this.endorsementForm.patchValue({w_benefit: +data.w_benefit });

    this.other_fees.patchValue(data);
    this.search_result={benefits: data.benefits};
 
  }
  

  endorsementPrint(id){
    this.spinner.show();

    this.product.endorsementPrint(id).subscribe((res:Blob)=>{
      this.spinner.hide();

      var blob = new Blob([res], {type: 'application/pdf'});
      var downloadURL = window.URL.createObjectURL(blob);
      var link = document.createElement('a');
      link.href = downloadURL;
      link.download = "endorsement-letter.pdf";
      link.click();
    },error=>{
      this.spinner.hide();
    });
  }



  update(){
    this.spinner.show()
    let endorsement = {
      endorsement_no: this.endorsementForm.getRawValue().endorsement_no,
      memo: this.endorsementForm.getRawValue().memo,
      policyNo: this.endorsementForm.getRawValue().policyNo,
      remarks: this.endorsementForm.getRawValue().remarks,
      w_benefit: this.endorsementForm.getRawValue().w_benefit==true? 1: 0,
      amnt_due: this.other_fees.value.amnt_due,
      comp_fee: this.other_fees.value.comp_fee,
      d_tech: this.other_fees.value.d_tech,
      doc_stamp: this.other_fees.value.doc_stamp,
      lgt: this.other_fees.value.lgt,
      misc_fee: this.other_fees.value.misc_fee,
      total_prem: this.other_fees.value.total_prem,
      vat: this.other_fees.value.vat,
      fst: this.other_fees.value.fst,
      cov: this.other_fees.value.cov
    }

    let data = {
      endorsement:endorsement,
      benefit:this.search_result.benefits || []
    }

    this.product.update( data, this.edit_data.id ).subscribe( res=>{
      this.basicModal.hide();
      // this.get_endorsement(1,false)
      this.search_result = ''
      this.other_fees.reset()
      this.spinner.hide()

      Swal.fire(
        'success',
        'Successfully updated endorsement!',
        'success'
      );
    },error=>{
      this.spinner.hide()

      let err=error.error;
      let msg='';

      Object.keys(err).forEach(function(key){
        msg+=err[key]+'<br/>';
      })

      Swal.fire(
        'Error',
        msg,
        'error'
      );
    
    })
  }


  on_select(){
    if(this.endorsementForm.getRawValue().w_benefit == false){
      this.endorsementForm.getRawValue().w_benefit = null;
    }
  }

  

  email_endorsement(){
    this.spinner.show()

    this.product.email_endorsement(this.email,this.endorse_id).subscribe(res=>{
      this.spinner.hide()
      Swal.fire(
        'success',
        res['msg'],
        'success'
      );
    },error=>{
      this.spinner.hide()
      Swal.fire(
        'Opps',
        'Something went wrong!',
        'error'
      );
    }
    )
  }



  getQuotationDetails(quoteId){
    this.spinner.show()

    this.product.getQuotationDetails(quoteId).subscribe(res=>{
      this.spinner.hide()
      this.quoteDetail=res;
    },error=>{
      this.spinner.hide()
      Swal.fire(
        'Opps',
        'Something went wrong!',
        'error'
      );
    });
  }


  get_request_endorsement(page, exports){
      this.spinner.show()

    let data = {
      export: exports,
      page: page,
      searchKey: this.searchText,
      dateto: this.dateto,
      datefrom: this.datefrom,
      area: this.area
    }  
    
    this.bill.get_request_endorsement(data)
      .subscribe( (res:any) => {
        if(exports){
          window.open(res);
        }
        else{
          this.endorsemet_request = res;

        }

      this.spinner.hide()

    },error => {
      this.spinner.hide()

      Swal.fire(
        'Error',
        'Something went wrong!',
        'error'
      );
    });
  } 



  // updateEndorsementRequest(data){
  //   this.cancellationForm.patchValue({
  //     reason: data.reason,
  //     remarks: data.remarks,
  //     policyno: data.policyno,
  //     assured_name: data.assured_name,
  //     date: data.date
  //   });

  //   this.updateEndorsement.show()


  // }


  deleteEndorsementRequest(data){
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!"
    }).then((result) => {
      if (result.value) {
        this.bill.delete_request_endorsement(data.id).subscribe(res => { 

          this.endorsemet_request.data = this.endorsemet_request.data.filter(item => item.id !== data.id);

          Swal.fire({
            title: 'Success',
            text: 'Request endorsement deleted successfully!',
            type: 'success'
          });
        },error=>{
          let err=error.error;
          let msg='';

          Object.keys(err).forEach(function(key){
            msg+=err[key]+'<br/>';
          });

          Swal.fire(
            'Error',
            msg,
            'error'
          );
        });
      }
    })
  }



  createEndorsement(data){

    this.endorsementForm.patchValue({
      policyNo: data.policyno,
      remarks: data.remarks,
      memo: data.reason,
      request_endorsement_id: data.id

    });

    this.basicModal.show();
  }


  requestEndorsement(){
    this.spinner.show();
    this.updateEndorsement.show();

    this.bill.request_endorsement(this.cancellationForm.value).subscribe((res: any) => {

      this.spinner.hide();
      this.updateEndorsement.hide();
      this.get_request_endorsement(1,false);

      Swal.fire({
        title: 'Success',
        text: 'Endorsement request created successfully!',
        type: 'success',
        confirmButtonText: 'OK'
      });

    },error => {
      this.spinner.hide();

      let err=error.error;
      let msg='';

      Object.keys(err).forEach(function(key){
        msg+=err[key]+'<br/>';
      })

      Swal.fire(
        'Error',
        msg,
        'error'
      );
    
      
    });
  }



  async disapproveRequestEndorsement(data){
    const { value: text } = await Swal.fire({
      input: "textarea",
      inputPlaceholder: "Type your message here...",
      inputAttributes: {
        "aria-label": "Type your message here"
      },
      showCancelButton: true
    });
    if (text) {

        let filter:any = {
          id :data.id,
          note_by_approver: text
        };

        this.bill.update_request_endorsement(filter).subscribe((res: any) => {
          this.get_request_endorsement(1,false)
          Swal.fire({
            title: 'Success',
            text: 'Request endorsement disapproved successfully!',
            type: 'success'
          }); 
        },error=>{
          this.spinner.hide();
          let err=error.error;
          let msg='';

          Object.keys(err).forEach(function(key){
            msg+=err[key]+'<br/>';
          });

          Swal.fire(
            'Error',
            msg,
            'error'
          );
        });

    }
  
  }
  



}
